﻿import { OutputField } from "@models/configurators/output-fields/output-field";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { eOutputFieldType } from "@models/enums";
import { ICadPositionConstraint } from "@models/entity-models";
import { Mate } from "@models/configurators/output-fields/cad/mates/mate";
import { KboOutputField } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@KboOutputField(CToken.CadPositionConstraint, eOutputFieldType.cadPositionConstraint)
export class CadPositionConstraint extends Mate implements ICadPositionConstraint {
    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public x: number;
    public y: number;
    public z: number;
    public xAngle: number;
    public yAngle: number;
    public zAngle: number;
}
